import LegacyInterceptor from '../LegacyInterceptor'

const api = new LegacyInterceptor()

export default {
  getRecebimento(start, end, prestadorId?) {
    let url = `/medico/recebimento/relatorio/mes/${start}/${end}`

    if (prestadorId) url += `?prestador=${prestadorId}`

    return api.get(url)
  },

  getRecebimentoFontePagadora(start, end, fontePagadora?, prestadorId?) {
    let url = `/medico/recebimento/relatorio/fonte-pagadora/${start}/${end}`

    if (fontePagadora) url = `/medico/recebimento/relatorio/fonte-pagadora/${fontePagadora}/${start}/${end}`
    if (prestadorId) url += `?prestador=${prestadorId}`

    return api.get(url)
  },

  getRecebimentoOld(fontePagadoraId, period, prestadorId?) {
    let url = `/recebimentos/fonte-pagadora/${fontePagadoraId}/periodo/${period}`

    if (prestadorId) url += `?prestador=${prestadorId}`

    return api.get(url)
  },

  getPdfData(start, end, fontePagadora, prestadorId?) {
    let url = `/medico/recebimento/relatorio/fonte-pagadora/${fontePagadora}/divergencias/${start}/${end}`

    if (prestadorId) url += `?prestador=${prestadorId}`

    return api.get(url)
  }
}
